/**
 * Last Stand: hits cost less once you are nearly out.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const LAST_STAND = {
  id: 'lastStand',
  branch: 'survival',
  tier: 3,
  title: 'Last Stand',
  blurb: 'Remain at your post. Your post is wherever you are currently standing.',
  maxRanks: 3,
  minLevel: 17,
  requires: ['ironConstitution'],
  statGrants: {},
  effects: [{ field: 'incomingDamage', perRank: -0.07, condition: 'whileHurt' }],
  damageModifiers: [],
} as const satisfies Perk;
